import { isActionsAllowed } from '@pages/WorkSchedule/utils';

import { WS_CONDITION_HOVER } from '@pages/WorkSchedule/constants/cellConditions';

import type { NWorkSchedule } from '@pages/WorkSchedule/WorkSchedule.types';

import type { BaseOptionType } from 'antd/es/select';
import type { MutableRefObject } from 'react';

export const handleMouseOver = (
  period: string[],
  employeeId: number,
  startTime: BaseOptionType,
  endTime: BaseOptionType,
  hoveredCells: MutableRefObject<string[]>,
  mode: NWorkSchedule.ScheduleMode,
  rights: {
    creationInPresentAndFeature: boolean;
    editionInPresentAndFeature: boolean;
    deletionInPresentAndFeature: boolean;
    editionInPast: boolean;
    deletionInPast: boolean;
  }
) => {
  return (period || []).forEach((date: string) => {
    const className = `.employee-${employeeId}.date-${date}`;
    const cell = document.querySelector(className);

    if (
      isActionsAllowed({
        date,
        schedule: !!cell?.classList.contains('preloaded'),
        mode,
        rights,
      })
    ) {
      const oldTimeRangeContainer = cell?.querySelector(
        '.time-range-container'
      );
      const newTimeRange = `${startTime.current.label} - ${endTime.current.label}`;

      if (oldTimeRangeContainer && !oldTimeRangeContainer?.textContent) {
        oldTimeRangeContainer.textContent = newTimeRange;
      }

      hoveredCells.current = [...hoveredCells.current, className];
      return cell?.classList.add(WS_CONDITION_HOVER);
    }
  });
};
